import {
  TournamentsLeaderboardsClient,
  LeaderboardGroup,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const tournamentsLeaderboardClient = new TournamentsLeaderboardsClient(
  apiConfig,
  undefined,
  axiosInstance
);

const handleGetLeaderboard = async ({
  type,
  page,
  limit,
  gameId,
  startDate,
  endDate,
}: {
  type?: LeaderboardGroup;
  page?: number;
  limit?: number;
  gameId?: string;
  startDate?: string;
  endDate?: string;
}) => {
  try {
    return (
      await tournamentsLeaderboardClient.getLeaderBoard(
        page,
        limit,
        gameId,
        startDate,
        endDate,
        type
      )
    ).data;
  } catch {
    return;
  }
};

export { handleGetLeaderboard };
